// extracted by css-extract-rspack-plugin
export default {"formContainer":"AgentVerificationUpdateStatusModal_formContainer__JFkgH"};